module.exports = __webpack_public_path__ + "static/media/subGoogle3.0bf289fb.png";